import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../components/Button";
import { SplashScreen } from "../../components/SplashScreen";

import backgroundLogin from "../../assets/images/background-login.svg";
import { Slide, ToastContainer } from "react-toastify";

const IS_SHOWEN = "isShowen";

const SignContractLayout = ({ children, disableSplashScreen = false }) => {
    const [animation, setAnimation] = useState("");
    const { t } = useTranslation("common");

    const handleTransitionEnd = (event) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        if (event.propertyName === "transform") {
            setAnimation("end");
        }
    };

    useEffect(() => {
        const isSplashScreenShowen = localStorage.getItem(IS_SHOWEN);
        if (!disableSplashScreen && !isSplashScreenShowen) {
            localStorage.setItem(IS_SHOWEN, "showen");
        }
    }, []);

    return (
        <>
            <ToastContainer transition={Slide} autoClose={2000} />
            <main>
                <section className="section-login">
                    <div
                        className={`section-login__wrap ${animation === "start" ? "section-login__wrap--mobile" : animation === "end" ? "section-login__wrap--mobile section-login__wrap--mobile-loaded" : ""}`}
                        onTransitionEnd={(event) => {
                            if (animation === "start") {
                                handleTransitionEnd(event);
                            }
                        }}
                    >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="section-login__form">{children}</div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="section-login__intro">
                                        <div className="section-login__intro-wrap">
                                            <img className="section-login__intro-logo" />
                                            <img className="section-login__background" src={backgroundLogin} alt="Login background" />
                                            <Button className="btn--primary" id="mobileLogin" onClick={() => setAnimation("start")}>
                                                {t("next")}
                                            </Button>
                                            <h2 className="section-login__intro-title">
                                                {t("poweredBy")}{" "}
                                                <span>
                                                    Equilibrio <sub>{t("KIDS APP")}</sub>
                                                </span>
                                            </h2>
                                            <h2 className="section-login__intro-title--mobile">
                                                {t("poweredBy")}{" "}
                                                <span>
                                                    Equilibrio <sub>{t("KIDS APP")}</sub>
                                                </span>
                                            </h2>
                                            <div className="section-login__version">
                                                v.<span>12.5.16</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {!disableSplashScreen && localStorage.getItem(IS_SHOWEN) !== "showen" && <SplashScreen />}
            </main>
        </>
    );
};

export default SignContractLayout;
